import * as React from 'react';
import { registerComponent } from '@avensia/excite';
import BaseProductListingPage from 'webapp/pages/BaseProductListingPage';

export default registerComponent<NordicNest.Api.CollectionPageApiModel>(props => {
  return <BaseProductListingPage {...props} />;
});
